import React, { Fragment, useEffect, useMemo, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Button, Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import Loader from "react-loaders";
import { ReactComponent as AddIcon } from "../../../../assets/utils/images/svgs/addBlue.svg";
import ContractTypenTable from "Pages/Coordinator/Instellingen/ContractTypen/ContractTypenTable";
import { useLocation, useNavigate } from "react-router";
import axiosInstance from "Api";
import ContractTypenService from "Api/Instellingen/ContractTypen";
import useSWR from "swr";
import { useApiMutation } from "services/useApiMutation";

const Contracttypen = () => {
    const navigate = useNavigate();
    const [communityId, setCommunityId] = useState('');
    const { trigger: saveContractMutation } = useApiMutation();
    const location = useLocation();
    const shouldForceRefetch = location.state?.forceRefetch;

    const {
        data: communityResponse,
        isLoading: communityLoading,
        mutate: communityMutate
    } = useSWR(
        "organizations-list",
        () => axiosInstance.get("organizations-list")
    );

    const communityList = communityResponse?.data?.data || [];

    
    useEffect(() => {
        if (shouldForceRefetch) {
            communityMutate();
        }
    }, [shouldForceRefetch]);

    useEffect(() => {
        if (!communityId && communityList.length) {
            setCommunityId(communityList[0].iCommunityId);
        }
    }, [communityList, communityId]);

    const {
        data: contractResponse,
        mutate: refreshContracts,
        isLoading: contractsLoading,
    } = useSWR(
        communityId
            ? ["contracts", communityId]
            : null,
        ([, communityId]) =>
            ContractTypenService.fetchContracts(communityId)
    );
    console.log(contractResponse?.data?.data,'contractResponsecontractResponsecontractResponsecontractResponse');

    const contractList =
        contractResponse?.data?.status
            ? contractResponse?.data?.data
            : [];

    const handleSave = () => {
        const data = { iCommunityId: communityId }
        saveContractMutation(() =>
            ContractTypenService.saveContract(data)
        ).then((response) => {
            if (response?.status == true) {
                navigate(`/c-instellingen/contracttypen/wijzigen-toevoegen/${response?.contractId}`, { state: { contractId: response?.contractId, communityId: communityId } });
            }
        }).catch((error) => console.log("catch error:", error))
    }

    const orgName = useMemo(() => {
        return communityList?.find(item => item.iCommunityId === Number(communityId))?.name || ""
    }, [communityId, communityList]);

    return (
        <Fragment>
            <PageHeading orgName={orgName} />
            <TransitionOnLoad>
                <Row className="mb-5">
                    <Col>
                       
                                {(contractsLoading || communityLoading) ?
                                    <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                    :
                                    <ContractTypenTable contractData={contractList} communityId={communityId} />
                                }
                          
                    </Col>
                </Row>

            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner">
                    <div className="d-flex gap-3 mr-4">
                        <div>
                            <select className={`form-select`} value={communityId} onChange={(e) => { setCommunityId(Number(e.target.value)) }}>
                                {communityList?.map(item => {
                                    return <option key={item.iCommunityId} value={item.iCommunityId}>{item.name}</option>
                                })}
                            </select>
                        </div>
                        <Button
                            outline
                            className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center"
                            type="button"
                            color="primary"
                            onClick={() => {
                                handleSave()
                            }}
                        >
                            Contracttype <AddIcon />
                        </Button>
                    </div>
                </CardFooter>
            </div>
        </Fragment>
    )
}

export default Contracttypen